module.exports = __webpack_public_path__ + "assets/img/2d8bc72efdb6ed53c92d9463b08074fe.png";